<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="chap1">INTRODUCTION</h1>
<blockquote>
<p class="noind" style="margin-top:30px;">I <span class="small">THEN TENDERED ON</span> explanation spontaneous and unsolicited concerning my own work, affording an insight as to its aesthetic, its daemon, its argument, its sorrow and its joy, its darkness, its sun-twinkle clearness.</p>
<p class="right">—Flann O’Brien</p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5-chap1.vue?06e1bfa8